import { render } from "./CarrierShare.vue?vue&type=template&id=63e8062c"
import script from "./CarrierShare.vue?vue&type=script&lang=js"
export * from "./CarrierShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__